// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2UCl2","bigColWidth":"Table_bigColWidth__G7QNS","biggerColWidth":"Table_biggerColWidth__ZL6sI","row":"Table_row__3LftF","col":"Table_col__8QDtQ"};